<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <b-link
            v-b-toggle.fees
            class="list-group-item item"
            :class="activeFees"
        >
            SUIVI DU CA&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="fees" :visible="openFees">
            <b-list-group-item
                :href="menuRoutes['fees-interactive']"
                class="item sub-item"
                :active="pageName === 'fees-interactive'"
                @click="setPageName('fees-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Tableau
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['fees-pivot-firm']"
                class="item sub-item"
                :active="pageName === 'fees-pivot-firm'"
                @click="setPageName('fees-pivot-firm')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par cabinet
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['fees-pivot-client']"
                class="item sub-item"
                :active="pageName === 'fees-pivot-client'"
                @click="setPageName('fees-pivot-client')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par client
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['fees-pivot-activity']"
                class="item sub-item"
                :active="pageName === 'fees-pivot-activity'"
                @click="setPageName('fees-pivot-activity')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par activité
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.evolution
            class="list-group-item item"
            :class="activeEvolution"
        >
            EVOLUTION N vs N-1&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="evolution" :visible="openEvolution">
            <b-list-group-item
                :href="menuRoutes['evolution-interactive']"
                class="item sub-item"
                :active="pageName === 'evolution-interactive'"
                @click="setPageName('evolution-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Tableau
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['evolution-pivot-firm']"
                class="item sub-item"
                :active="pageName === 'evolution-pivot-firm'"
                @click="setPageName('evolution-pivot-firm')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par cabinet
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['evolution-pivot-client']"
                class="item sub-item"
                :active="pageName === 'evolution-pivot-client'"
                @click="setPageName('evolution-pivot-client')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par client
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.billedVsReal
            class="list-group-item item"
            :class="activeBilledVsReal"
        >
            MARGE&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>

        <b-collapse id="billedVsReal" :visible="openBilledVsReal">
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-filterable']"
                class="item sub-item"
                :active="pageName === 'billed-vs-real-filterable'"
                @click="setPageName('billed-vs-real-filterable')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Analyse par
                client
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-interactive']"
                class="item sub-item"
                :active="pageName === 'billed-vs-real-interactive'"
                @click="setPageName('billed-vs-real-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Analyse par
                cabinet
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-pivot']"
                class="item sub-item"
                :active="pageName === 'billed-vs-real-pivot'"
                @click="setPageName('billed-vs-real-pivot')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD par client
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-export'] + '/' + year"
                class="item sub-item"
            >
                <i class="fa-fw fal fa-file-excel menu-sub-icon"></i>Export
                Excel
            </b-list-group-item>
        </b-collapse>

        <b-link
            :href="menuRoutes['cador-update']"
            :active="pageName === 'cador-update'"
            class="list-group-item item"
            @click="setPageName('cador-update')"
        >
            API CADOR
        </b-link>
        <data-filter
            v-if="pageName !== 'billed-vs-real-pivot'"
            :show-activation-filter="false"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import DataFilter from '../../../common/components/DataFilterNew.vue'

export default {
    name: 'FeesDashboardVerticalMenu',

    components: {
        DataFilter,
    },

    props: {
        page: '',
    },

    data() {
        return {
            openFees: false,
            activeFees: '',
            openEvolution: false,
            activeEvolution: '',
            openBilledVsReal: false,
            activeBilledVsReal: '',
        }
    },

    async created() {
        await this.$store.dispatch('reportingVM/getFilters')
        await this.$store.dispatch('dashboardVM/getRoutes')
        this.$store.commit('dashboardVM/SHOW_VERTICAL_MENU')
        this.handleFeesMenu()
        this.handleEvolutionMenu()
        this.handleBilledVsRealMenu()
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },
        handleFeesMenu() {
            this.openFees = [
                'fees-interactive',
                'fees-pivot-firm',
                'fees-pivot-client',
                'fees-pivot-activity',
            ].includes(this.pageName)
            this.activeFees = this.openFees ? 'active' : ''
        },
        handleEvolutionMenu() {
            this.openEvolution = [
                'evolution-interactive',
                'evolution-pivot-firm',
                'evolution-pivot-client',
            ].includes(this.pageName)
            this.activeEvolution = this.openEvolution ? 'active' : ''
        },
        handleBilledVsRealMenu() {
            this.openBilledVsReal = [
                'billed-vs-real-filterable',
                'billed-vs-real-interactive',
                'billed-vs-real-pivot',
            ].includes(this.pageName)
            this.activeBilledVsReal = this.openBilledVsReal ? 'active' : ''
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.dashboardVM.showVerticalMenu,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
